import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Paper, Table, TableHead, TableBody, TableRow, TableCell, Tooltip, withStyles,
} from '@material-ui/core';
import { Spin } from 'antd';
import { getGroupsListRequest, setFilterGroups } from '../redux/actions/get_groups_list.actions';
import TablePaginationActions from '../../../../components/pagination/TablePaginationActions';
import { table_styles } from '../../../../components/TableStyles';
import EnhancedTableToolbar from '../../../../components/table_toolbar/table_toolbar';

const mapStateToProps = (state) => {
    const { groupsList, filteredGroups, loading } = state.UserManagement.User_group.User_group_list;
    const { usersQuantity } = state.UserManagement.User_group_quantity;
    return {
        groupsList, loading, usersQuantity, filteredGroups,
    };
}; const
    groupListTitles = ['#', 'Name', 'Abbr', 'Description', 'Users', 'Status', 'Action'];

export default connect(mapStateToProps, null)(withStyles(table_styles)(class CustomPaginationActionsTable extends Component {
    state = {
        page: 0,
        rowsPerPage: 25,
        filteredList: null,
    };

    componentDidMount() {
        this.props.dispatch(getGroupsListRequest());
    }

    handleChangePage = (event, page) => this.setState({ page });

    handleChangeRowsPerPage = event => this.setState({ rowsPerPage: event.target.value });

    handleSearch = event => this.props.dispatch(setFilterGroups(event.target.value));

    updateData = (event) => {
        this.props.dispatch(getGroupsListRequest());
        event.target.style.webkitTransform = 'rotate(180deg)';
    };

    render() {
        const { classes: { root, tableWrapper, table }, loading, filteredGroups } = this.props; const
            { rowsPerPage, page } = this.state;
        return (
            <Spin spinning={loading} tip="Loading ...">
                <Paper className={root}>
                    <EnhancedTableToolbar
                        displayDataList={filteredGroups}
                        updateData={this.updateData}
                        searchPlaceholder="Search by group name or abbreviation"
                        handleSearch={this.handleSearch}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        TablePaginationActionsWrapped={TablePaginationActions}
                    />
                    <div className={tableWrapper}>
                        <Table className={table}>
                            <TableHead>
                                <TableRow>
                                    {groupListTitles.map((title, index) => <TableCell key={index}>{title}</TableCell>)}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    (filteredGroups && filteredGroups.length)
                                        ? filteredGroups.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>{item.name}</TableCell>
                                                    <TableCell>{item.abbr}</TableCell>
                                                    <TableCell>{item.description ? item.description : ' '}</TableCell>
                                                    <TableCell>{(item.users.length || item.users.length === 0) ? item.users.length : 0}</TableCell>
                                                    <TableCell>{item.is_active ? 'Active' : 'Suspended'}</TableCell>
                                                    <TableCell>
                                                        <div className="users_table_icons">
                                                            <Link to={{ pathname: `/UserManagement/User_group_update/${item._id}` }}>
                                                                <Tooltip title="Edit group" placement="top">
                                                                    <span className="lnr lnr-pencil" />
                                                                </Tooltip>
                                                            </Link>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        : (
                                            <TableRow key="no_data">
                                                <TableCell>No data upon request</TableCell>
                                            </TableRow>
                                        )
                                }
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
            </Spin>
        );
    }
}));



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/components/GroupsList.js